module.exports = __webpack_public_path__ + "img/answer.05409f66.svg";